export default __webpack_public_path__ + "static/media/guxImage.20686123.svg";